import { getBoardIdFromPath, getClipIdFromPath } from '~/utils/PathUtils';

export type WorkspaceAgentCurrentViewStoreSnapshot = {
  boardId: string | undefined;
  clipAssetId: string | undefined;
  clipId: string | undefined;
  isKanbanView: boolean;
};

export type WorkspaceAgentCurrentViewInvalidationTargets = {
  assetId: string | undefined;
  boardId: string | undefined;
  clipId: string | undefined;
  isKanbanView: boolean;
};

/**
 * Current board/clip/kanban at flush time. Board and clip come from the URL; asset id is the open
 * modal's store clip when it matches that URL clip (the clip-id exception for metadata/custom fields).
 */
export const getWorkspaceAgentCurrentViewInvalidationTargets = (
  pathname: string,
  storeSnapshot: WorkspaceAgentCurrentViewStoreSnapshot,
): WorkspaceAgentCurrentViewInvalidationTargets => {
  const clipId = getClipIdFromPath(pathname);

  return {
    assetId:
      clipId && storeSnapshot.clipId === clipId && storeSnapshot.clipAssetId ? storeSnapshot.clipAssetId : undefined,
    boardId: getBoardIdFromPath(pathname) ?? storeSnapshot.boardId,
    clipId,
    isKanbanView: storeSnapshot.isKanbanView,
  };
};
